import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, NgModule, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Step } from './steps.interface';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-steps',
  templateUrl: './steps.component.html',
  styleUrl: './steps.component.scss',
})
export class StepsComponent implements OnChanges {
  /** Steps */
  @Input() steps: Step[] = [];
  /** Current step */
  @Input() currentStep = 1;
  /** Full width flag */
  @Input() fullWidth = false;
  /** Show line flag */
  @Input() showLine = false;
  /** Gap steps */
  @Input() gap = 16;
  /** Emit step change */
  @Output() currentStepChange: EventEmitter<number> = new EventEmitter<number>();

  /**
   * Listen to the changes of the steps
   * @param changes
   */
  ngOnChanges(changes: SimpleChanges): void {
    this.currentStep = changes.currentStep?.currentValue ?? this.currentStep;
    this.steps = changes.steps?.currentValue ?? this.steps;
    document
      .querySelector('#templates-container')
      ?.setAttribute(
        'style',
        `width: calc(100% * ${this.steps.length} + ${this.gap}px * ${this.steps.length}); left: calc(-100% * ${this.currentStep - 1} - ${this.gap}px * ${this.currentStep - 1}); gap: ${this.gap}px;`
      );
  }

  /**
   * Go to the step
   * @param step
   */
  goToStep(step: number): void {
    if (this.steps[step - 1].completed) {
      this.currentStep = step;
      this.currentStepChange.emit(this.currentStep);
    }
  }
}

@NgModule({
  declarations: [StepsComponent],
  exports: [StepsComponent],
  imports: [CommonModule, TranslateModule],
})
export class SystemStepsModule {}
